"use client";
import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";

const PaymentPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>

      <main className="flex pb-4 w-full bg-[#fff8ef] max-md:p-5 max-sm:p-4">
        <section className="flex-1">
          

          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mt-10 mx-auto text-gray-700 space-y-5">
             <div className="flex items-center justify-center gap-3 mb-8">
                 <div
            className=" text-3xl sm:text-3xl md:text-3xl lg:text-4xl 
      font-bold leading-none text-black 
      tracking-[1px] md:tracking-[2px] 
      hover:opacity-80 transition-opacity duration-200 
      flex-shrink-0 min-w-0
      
      lg:[-webkit-text-stroke:2px_gray-700]"
            
            aria-label="Manaprint Home"
          >
            Payment Policy
          </div>
              </div>
            <p>
              <strong>Manaprint</strong> accepts secure online payments through
              trusted payment gateways.
            </p>

            <p>
              <strong>Accepted payment methods:</strong> Credit Cards, Debit
              Cards, UPI, Net Banking, and Wallets (as available).
            </p>

            <p>
              <strong>Payment security:</strong> all transactions are encrypted
              and processed securely. We do not store your card or payment
              details.
            </p>

            <p>
              <strong>Order confirmation:</strong> your order is confirmed only
              after successful payment.
            </p>

            <p>
              <strong>Failed payments:</strong> if a payment fails but the amount
              is debited, it is usually reversed by your bank within 5–7
              business days.
            </p>

            <p>
              For payment-related issues, contact us at
              <strong> manaprint6@gmail.com</strong>.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PaymentPolicy;
